<template>
  <div>
    <template v-if="hasAdvPermission">
      <v-card v-if="!isEditorDoctorComputed" class="p-0 overflow-hidden" rounded="xl">
        <upload-image-dialog
          size="300"
          :aspect-ratio="1480 / 600"
          :max-file-size="bannerSize"
          color="white"
          placeholder="將圖片拖拉到這裡或選擇檔案，檔案大小限制2MB內，圖片尺寸為1480×600px"
          hide-detail
          img-class="rounded-t-xl"
          img-style="border-radius: 0px;width: 100%"
          :disabled="bannerLoading"
          @submit="onUploadBanner"
        >
          <v-overlay :value="bannerLoading" absolute z-index="2">
            <v-progress-circular indeterminate size="64"/>
          </v-overlay>
          <v-btn
            class="text-subtitle-2 rounded-lg"
            dark
            style="
            width: 150px;
            height: 40px;
            position: absolute;
            top: 10px;
            right: 30px;
            z-index: 1;
            background: #2727277e;
          "
          >
            <v-icon dark size="20" class="mr-2">
              mdi-camera
            </v-icon>
            上傳圖片
          </v-btn>
          <v-img height="300" :src="doctor.banner"/>
        </upload-image-dialog>
        <div style="padding: 20px;">
          <div class="d-flex justify-space-between" :class="{'align-center': !$vuetify.breakpoint.xsOnly}">
            <div class="d-flex" :class="{'flex-wrap': $vuetify.breakpoint.xsOnly}" style="gap: 8px;">
              <div
                class="doctor-image text-center px-5 py-5"
                style="position: relative; width: 200px;"
              >
                <v-avatar
                  size="200"
                  style="position: absolute; bottom: 0; left: -2px;"
                >
                  <img
                    :src="doctor.profile"
                    alt=""
                  >
                </v-avatar>
              </div>

              <v-btn
                v-if="!!doctor.line_page"
                class="px-10"
                color="green-6"
                dark
                :href="doctor.line_page"
                target="_blank"
              >
                <v-icon class="px-1" color="white" size="20">
                  $line
                </v-icon>
                加入LINE好友
              </v-btn>
            </div>
            <v-btn
              color="teal lighten-2"
              class="text-subtitle-2 rounded-lg"
              dark
              style="width: 100px; height: 40px"
              @click="isEditorDoctorComputed = true"
            >
              <v-icon dark size="15" class="mr-2">
                mdi-pencil
              </v-icon>
              編輯
            </v-btn>
          </div>
        </div>
        <v-row no-gutters :class="{'flex-nowrap': $vuetify.breakpoint.lgAndUp}"
               style="padding: 10px 30px 50px 30px; row-gap: 16px;">
          <v-col cols="12" md="8">
            <div class="d-flex justify-space-between align-center mb-5">
              <div
                class="d-flex align-center flex-wrap"
                style="gap: 0.5rem"
              >
                <div class="d-flex align-center">
                  <v-icon color="teal lighten-2" size="30">
                    mdi-check-circle
                  </v-icon>
                  <h4 class="text-h4 font-weight-bold text-no-wrap">
                    {{ doctor.alias || doctor.doctor_name }}
                  </h4>
                </div>
              </div>
            </div>
            <p class="subtitle-1" style="color: #3d3d3d">
              <v-icon size="16">
                mdi-map-marker-outline
              </v-icon>
              服務區域： {{ doctor.service_area?.join(",") }}
            </p>
            <div class="d-flex flex-wrap" style="gap: 1rem">
              <div
                v-for="clinic in doctor.clinics"
                :key="'clinic_' + clinic.clinic_name"
                class="text-no-wrap"
              >
                <v-icon :color="clinic.color" size="10" class="mx-1">
                  mdi-circle
                </v-icon>
                <a
                  class="subtitle-1 text-decoration-underline"
                  style="
                  color: #3d3d3d;
                  vertical-align: top;
                  text-underline-offset: 0.2em;
                "
                >
                  {{ clinic.clinic_name }}
                </a>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="auto" class="ml-lg-auto"
                 :style="{'min-width': $vuetify.breakpoint.lgAndUp ? '240px' : 'unset'}">
            <v-list
              dense
              min-height="20"
            >
              <v-list-item
                v-for="(link, idx) in doctor.social_item_structure"
                v-if="link.url && link.label !== 'LINE'"
                :key="idx"
                class="d-flex align-center mb-2"
                style="min-height: fit-content; gap: 0.3rem"
              >
                <v-icon color="black" size="16">
                  {{ getSocialIcon(link.label) }}
                </v-icon>
                <v-list-item-content class="py-0">
                  <a
                    :href="link.url"
                    class="black--text text-body-2 text-decoration-underline px-0 text-truncate"
                    target="_blank"
                  >
                    {{ link.name || link.label }}
                  </a>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-card>
    </template>
    <template v-else>
      <v-card v-if="!isEditorDoctorComputed" class="p-0" rounded="xl">
        <div class="d-flex" style="padding: 30px;">
          <div class="doctor-image text-center" style="width: 150px">
            <v-avatar size="100">
              <img
                :src="doctor.profile"
                alt=""
              >
            </v-avatar>
          </div>
          <div class="flex-grow-1">
            <div class="d-flex justify-space-between mb-2" :class="{'flex-wrap': $vuetify.breakpoint.xsOnly}">
              <div class="text-wrap d-flex flex-wrap" style="gap: 1rem">
                <h4 class="text-h4 font-weight-bold text-no-wrap">
                  {{ doctor.alias || doctor.doctor_name }}
                </h4>
              </div>
              <v-btn
                color="teal lighten-2"
                class="text-subtitle-2 rounded-lg ml-auto"
                dark
                style="width: 100px; height: 40px;"
                :style="{'order': $vuetify.breakpoint.xsOnly ? '-1' : 'unset'}"
                @click="isEditorDoctorComputed = true"
              >
                <v-icon dark size="15" class="mr-2">
                  mdi-pencil
                </v-icon>
                編輯
              </v-btn>
            </div>
            <p class="subtitle-1" style="color: #3d3d3d">
              <v-icon size="16">
                mdi-map-marker-outline
              </v-icon>
              服務區域： {{ doctor.service_area?.join(",") }}
            </p>
            <div class="d-flex flex-wrap" style="gap: 1rem">
              <div
                v-for="clinic in doctor.clinics"
                :key="'clinic_' + clinic.clinic_name"
                class="text-no-wrap"
              >
                <v-icon :color="clinic.color" size="10" class="mx-1">
                  mdi-circle
                </v-icon>
                <a
                  class="subtitle-1 text-decoration-underline"
                  style="
                  color: #3d3d3d;
                  vertical-align: top;
                  text-underline-offset: 0.2em;
                "
                >
                  {{ clinic.clinic_name }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </template>
    <doctor-form
      v-if="isEditorDoctorComputed && userInfo"
      :show.sync="isEditorDoctorComputed"
      :doctor="doctor"
      :hasAdvPermission="hasAdvPermission"
      :hasGuideLinePermission="hasGuideLinePermission"
      :avatarLoading="avatarLoading"
      @update="onUpdate"
      @uploadDoctorAvatar="onUploadAvatar"
    />
  </div>
</template>

<script>
import UploadImageDialog from "@/components/utils/UploadImageDialog.vue";
import DoctorForm from "@/components/settings/doctor/v2/DoctorForm.vue";
import { getSocialIcon } from "@/utils/tool";

export default {
  name: "DoctorBasicInfoSection",

  components: { UploadImageDialog, DoctorForm },

  props: {
    doctor: {
      type: Object,
      required: true,
    },
    userInfo: {
      type: Object,
      default: null,
    },
    hasAdvPermission: {
      type: Boolean,
      default: false,
    },
    hasGuideLinePermission: {
      type: Boolean,
      default: false,
    },
    avatarLoading: {
      type: Boolean,
      default: false,
    },
    bannerLoading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      bannerSize: 2 * 1024 * 1024,
    };
  },

  computed: {
    isEditorDoctorComputed: {
      get() {
        return this.$store.getters["doctorSetting/isEditorDoctor"];
      },
      set(isEdit) {
        this.$store.commit("doctorSetting/setEditorDoctor", isEdit);
      },
    },
  },

  methods: {
    getSocialIcon,
    onUploadBanner(file) {
      this.$emit("upload-banner", file);
    },
    onUploadAvatar(file) {
      this.$emit("upload-avatar", file);
    },
    onUpdate(payload) {
      this.$emit("update-info", payload);
    },
  },
};
</script>
